<template>
  <el-select v-model="valueTemp"
             :disabled="disabled"
             :placeholder="placeholder"
             :clearable="clearable"
             :size="size"
             filterable
             style="width: 100%;">
    <el-option v-for="item in data"
               :key="item.id"
               :label="item.label"
               :value="item.id">
    </el-option>
  </el-select>
</template>

<script>
export default {
  name: "EspEnumEdit",
  data() {
    return {
      valueTemp: this.value
    }
  },
  props: {
    data: {
      type: Array,
      default() {
        return []
      }
    },
    value: {
      type: Number
    },
    disabled: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: "请选择"
    },
    size: {
      type: String,
      default: "small"
    },
    clearable: {
      type: Boolean,
      default: true
    }
  },
  watch: {
    valueTemp: {
      handler(newVal, oldVal) {
        var val = newVal ? newVal : null;
        this.$emit("input", val);
        this.$emit("change", val);
      }
    },
    value: {
      handler(newVal, oldVal) {
        this.valueTemp = this.value;
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/common/enum/EspEnumEdit.vue